import { createFileRoute, redirect } from '@tanstack/react-router';
import { normalizeAnalysisSearch } from '@/lib/route-search';

export const Route = createFileRoute('/seo')({
  beforeLoad: () => {
    throw redirect({ to: '/analysis', search: normalizeAnalysisSearch({ tab: 'seo' }) });
  },
});
